var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavItem',{staticClass:"lg:hidden",attrs:{"title":"Open menu"},on:{"click":_vm.showMobileSidebar}},[_c('HamburgerIcon',{staticClass:"w-4"}),_vm._v(" "),_c('span',{staticClass:"hidden ml-6 border-b border-black 2xl:block"},[_vm._v("\n    "+_vm._s(_vm.$t('Menu_ShopAll'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }